import playoffCaptainAPI from '../../../utils/playoffCaptainAPI';
import toolkitApi from '../../toolkitApi';

import awardsAPI from './awardsAPI';
import AWARDS from './constants';
import selectors, { addAwardSlug } from './selectors';

export const baseAwardsEndpoint =
    '/site/api/trophy' +
    '?include=id' +
    '&include=name' +
    '&include=briefDescription' +
    '&include=footnote' +
    '&include=description' +
    '&include=imageUrl' +
    '&include=trophyCategory' +
    '&sort=name';

const SHOW_MULTIPLE_SEASON_WINNERS = [AWARDS.LESTER_PATRICK_TROPHY, AWARDS.WILLIE_O_REE_COMMUNITY_HERO_AWARD];

export const apiSlice = toolkitApi.injectEndpoints({
    endpoints: (build) => ({
        baseAwards: build.query({
            query: () => ({
                url: baseAwardsEndpoint,
            }),
            transformResponse: ({ data }) => data.map(addAwardSlug),
        }),
        awards: build.query({
            async queryFn(args, queryApi, extraOptions, fetchWithBQ) {
                if (!args?.id) {
                    return { data: [] };
                }

                const { data: awardRecords } = await fetchWithBQ(awardsAPI.awardEndpoint(args));
                const seasonAwardMap = selectors.groupRecordsBySeasonStatus(awardRecords.data);

                const awards = SHOW_MULTIPLE_SEASON_WINNERS.includes(args.slug)
                    ? selectors.getAllAwards(seasonAwardMap)
                    : selectors.getAwardsBySeason(seasonAwardMap);

                if (args.slug === AWARDS.STANLEY_CUP) {
                    const { data: playoffCaptains } = await fetchWithBQ(playoffCaptainAPI.playoffCaptainEndpoint);
                    selectors.mergeCaptainData(awardRecords.data, playoffCaptains.data);
                }

                return { data: awards };
            },
        }),
    }),
});
